import { useMutation } from '@tanstack/react-query';
import type { UpdateApiTokenRequestDto } from '../../model';
import { updateApiToken } from '../requests';
import type { RequestHandlerOptions } from '@/shared/api';

export function useUpdateApiToken(options: RequestHandlerOptions = {}) {
  const mutation = useMutation<void, Error, UpdateApiTokenRequestDto>({
    mutationFn: args => updateApiToken(args, options),
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
